export function telefonNormalize(girdi) {
    const ham = (girdi ?? "").replace(/[^\d+]/g, "");
    if (!ham)
        return { gecerli: false, numara: "", hata: "Phone number is required." };
    let d = ham.replace(/\D/g, "");
    if (d.startsWith("90") && d.length === 12)
        d = d.slice(2);
    else if (d.startsWith("0"))
        d = d.slice(1);
    if (d.length !== 10 || !d.startsWith("5"))
        return { gecerli: false, numara: ham, hata: "Phone must be 10 digits starting with 5 (e.g. 0554 178 17 74)." };
    return { gecerli: true, numara: "0" + d };
}
/** Ekranda okunur biçim: 0554 178 17 74 */
export function telefonYaz(numara) {
    const t = telefonNormalize(numara);
    if (!t.gecerli)
        return numara;
    const d = t.numara;
    return `${d.slice(0, 4)} ${d.slice(4, 7)} ${d.slice(7, 9)} ${d.slice(9)}`;
}
//# sourceMappingURL=telefon.js.map